import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "max-w-[800px]"
}
const _hoisted_2 = { class: "flex justify-center items-center w-full flex-col md:flex-row" }
const _hoisted_3 = { class: "my-6" }
const _hoisted_4 = { class: "flex flex-col w-full max-w-[500px] ml-0 mt-8 md:ml-8 md:mt-0 md:max-w-none" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "flex flex-col items-start" }
const _hoisted_7 = { class: "opacity-70" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "NFT Amount", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "opacity-50" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "self-center text-xl opacity-60 m-4" }, "x", -1)
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = { class: "opacity-70" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "self-center text-xl opacity-60 m-4" }, "=", -1)
const _hoisted_16 = { class: "flex flex-col items-end" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-70" }, "Current value", -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "opacity-50" }
const _hoisted_20 = { class: "flex justify-between items-center" }
const _hoisted_21 = { class: "opacity-70" }
const _hoisted_22 = { class: "flex flex-col items-end" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "block text-right opacity-50" }
const _hoisted_25 = { class: "flex justify-between items-center" }
const _hoisted_26 = { class: "flex flex-row items-center" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "Funds available", -1)
const _hoisted_28 = { class: "flex flex-col items-end" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "block text-right opacity-50" }
const _hoisted_31 = {
  key: 0,
  class: "flex justify-between items-center mt-8"
}
const _hoisted_32 = { class: "w-[55%]" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-80 mr-1" }, "Owner:", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "text-red-400"
}
const _hoisted_36 = {
  key: 1,
  class: "opacity-70"
}
const _hoisted_37 = {
  key: 1,
  class: "flex justify-between items-center mt-8"
}
const _hoisted_38 = { class: "opacity-70 w-[55%]" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nft_preview = _resolveComponent("nft-preview")!
  const _component_information_circle_outline = _resolveComponent("information-circle-outline")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_indicator = _resolveComponent("indicator")!
  const _component_nomad_button = _resolveComponent("nomad-button")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_history = _resolveComponent("history")!

  return (_ctx.token)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_nft_preview, {
              size: 300,
              asset: _ctx.asset,
              amount: _ctx.originalAmount.toString()
            }, null, 8, ["asset", "amount"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                    trigger: _withCtx(() => [
                      _createVNode(_component_n_icon, { class: "pt-[2px] ml-1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_information_circle_outline)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" The maximum amount that can be accessed using this NFT ")
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.originalAmount)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.toDecimals(_ctx.originalAmount.toString(), _ctx.token.decimals, 6)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.token.symbol), 1)
              ]),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, [
                  _createTextVNode(" Recovery Pool "),
                  _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                    trigger: _withCtx(() => [
                      _createVNode(_component_n_icon, { class: "pt-[2px]" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_information_circle_outline)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" The percentage of this asset that has been recovered ")
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.percentage)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.percentage), 1))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                (_ctx.recovered && _ctx.available)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.toDecimals(_ctx.recovered.add(_ctx.available).toString(), _ctx.token.decimals, 6)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.token.symbol), 1)
              ])
            ]),
            _createVNode(_component_n_divider),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, [
                _createTextVNode(" Accessed "),
                _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                  trigger: _withCtx(() => [
                    _createVNode(_component_n_icon, { class: "pt-[2px]" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_information_circle_outline)
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" The total amount of recovered funds that have been accessed using this NFT ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_22, [
                (_ctx.recovered)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, "- " + _toDisplayString(_ctx.toDecimals(_ctx.recovered.toString(), _ctx.token.decimals, 6)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.token.symbol), 1)
              ])
            ]),
            _createVNode(_component_n_divider),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                (_ctx.available && _ctx.available > 0)
                  ? (_openBlock(), _createBlock(_component_indicator, {
                      key: 0,
                      class: "mr-1"
                    }))
                  : _createCommentVNode("", true),
                _hoisted_27
              ]),
              _createElementVNode("div", _hoisted_28, [
                (_ctx.available)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.toDecimals(_ctx.available.toString(), _ctx.token.decimals, 6)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.token.symbol), 1)
              ])
            ]),
            (!_ctx.connected || _ctx.walletAddress !== _ctx.owner)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("span", null, _toDisplayString(_ctx.owner.slice(0, 13) + '...'), 1),
                    _hoisted_34,
                    (_ctx.connected && _ctx.walletAddress !== _ctx.owner)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, " Connected wallet is not the owner "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_36, " Connect wallet to access funds "))
                  ]),
                  _createVNode(_component_nomad_button, {
                    primary: "",
                    onClick: _ctx.connectWallet
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Connect Wallet ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("span", _hoisted_38, [
                    (!_ctx.allowed)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, " You must be verified to access recovered funds. Check your status with CoinList Verify+ "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_40, " As funds are recovered, more will become available. "))
                  ]),
                  (_ctx.recovering)
                    ? (_openBlock(), _createBlock(_component_nomad_button, {
                        key: 0,
                        primary: "",
                        disabled: "",
                        class: "flex justify-center w-[116px]"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_spin, {
                            size: "tiny",
                            stroke: "#000"
                          })
                        ]),
                        _: 1
                      }))
                    : (!_ctx.allowed)
                      ? (_openBlock(), _createBlock(_component_nomad_button, {
                          key: 1,
                          primary: "",
                          onClick: _ctx.toCoinList
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" CoinList Verify+ ")
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_nomad_button, {
                          key: 2,
                          primary: "",
                          disabled: !_ctx.available || _ctx.available.isZero(),
                          onClick: _ctx.accessFunds
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Access Funds ")
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"]))
                ]))
          ])
        ]),
        _createVNode(_component_history, {
          token: _ctx.token,
          recovered: _ctx.recovered,
          history: _ctx.nftHistory
        }, null, 8, ["token", "recovered", "history"])
      ]))
    : _createCommentVNode("", true)
}